import { defineStore } from 'pinia';
import { axios } from '@boot/axios.js';
/**
 * Return the default state for the disconnections store.
 */
function getDefaultState() {
    return {
        disconnectedAssets: new Map()
    };
}
/**
 * Store for managing device disconnection tracking.
 */
export const useDisconnectionsStore = defineStore('disconnections', {
    state: () => getDefaultState(),
    getters: {
        /**
         * Get asset disconnection details.
         */
        getDeviceDisconnection: state => {
            return (assetId) => {
                const id = Number(assetId);
                if (state.disconnectedAssets.has(id)) {
                    return state.disconnectedAssets.get(id) || null;
                }
                return null;
            };
        }
    },
    actions: {
        /**
         * Reset store state.
         */
        resetState() {
            this.$reset();
        },
        /**
         * Load the current disconnections for the given facility.
         */
        async loadDisconnectionStatusesAction(payload) {
            const { facilityId } = payload;
            try {
                // load device disconnections
                const response = await axios.get(`disconnections/current/?device__facility=${facilityId}`);
                const disconnections = response.data;
                // Empty all the disconnections, since on
                // every call we get the fresh state of
                // active disconnections
                this.disconnectedAssets = new Map();
                // If there are active disconnections
                // populate the store state.
                if (disconnections.length > 0) {
                    disconnections.forEach(disconnection => {
                        disconnection.assets.forEach(assetId => {
                            this.disconnectedAssets.set(assetId, {
                                assetId: assetId,
                                device: disconnection.device,
                                start: disconnection.start
                            });
                        });
                    });
                }
            }
            catch (error) {
                console.error('Failed to load disconnections due to: ', error);
                throw error;
            }
        },
        /**
         * Add asset's disconnection status to store.
         */
        addDisconnectionAction(disconnections) {
            disconnections.assets.forEach(assetId => {
                this.disconnectedAssets.set(assetId, {
                    assetId: assetId,
                    device: disconnections.device,
                    start: disconnections.start
                });
            });
        },
        /**
         * Reset the disconnectedAssets status.
         */
        resetDisconnectionsAction() {
            this.disconnectedAssets = new Map();
        }
    }
});
